import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Icon from 'react-icons-kit'
import { ic_check_circle } from 'react-icons-kit/md/ic_check_circle'
import {creditCard} from 'react-icons-kit/fa/creditCard'
import { connect } from 'react-redux'
import { withRouter } from "react-router-dom";
import axios from 'axios';
import ReactGA from 'react-ga'


import './Store.css'


export const decode = s => atob(decodeURIComponent(s))
export const encode = s => encodeURIComponent(btoa(s))
const encode_qs = s => {
    let qs = []
    for (let [k, v] of Object.entries(s)) {
        qs.push(`${encode(k)}=${encode(v)}`)
    }
    return qs.join('&')
}
const decode_qs = qs => {
    let decoded = {}
    let key_values = qs.split('&')
    key_values.forEach(key_value => {
        let k = key_value.split('=')[0]
        let v = key_value.split('=')[1]
        decoded[decode(k)] = decode(v)
    })
    return decoded
}

const get_redirect = (plan, duration, username, item_name, cmd) =>
    `https://paypal.proxies.lol/purchase?${encode_qs({
        notify_url: `https://candidgirls.io/api/paypal/ipn?plan_id=${plan.id}`,
        cmd,
        price: plan.price,
        duration,
        item_name,
        custom: username,
        return_url: 'https://candidgirls.io/success',
    })}`

let PaymentTier = ({ title, price, plan_id, benefits, color_scheme, paypal_available, paypal_message }) =>
    <div className={`payment_tier ${color_scheme} card`}>
        <div className={'payment_tier_info'}>
            <h2>{title}</h2>
            <h4 className='old_price'>${(Math.ceil((parseFloat(price) * 2)) - 0.01).toFixed(2)}</h4>
            <h5 className='price'>SALE: ${price}</h5>
            {benefits.map((b, i) => <><h3 className='benefit'>{b}</h3>{i < benefits.length - 1 ? <hr /> : null}</>)}
        </div>
        <Button variant="contained" className={'buy_now'} disabled={paypal_available !== true} onClick={() => {
            ReactGA.event({
                category: 'Ecommerce',
                action: 'Clicked Buy',
                label: `$${price}`
            })
            window.location = `/purchase/${plan_id}` // even if not signed in
        }
        }>
            <Icon icon={creditCard} className='unlock_icon' />Pay with Credit Card
        </Button>
        {paypal_available !== true && <p role='status'>{paypal_message || 'Premium checkout is temporarily unavailable. Please try again soon.'}</p>}
    </div>

class StorePage extends Component {
    state = {
        plans: [
            // {
            //     title: '48hr Trial',
            //     price: '4.99',
            //     id: 'plan_id1',
            //     benefits: ['No recurring charges', 'Full Premium Access'],
            //     color_scheme: 'white'
            // },
            // {
            //     title: 'Monthly Subscription',
            //     price: '19.99',
            //     id: 'plan_id2',
            //     benefits: ['Unlimited Premium Access', 'Unlimited High Definition Downloads'],
            //     color_scheme: 'purple'
            // },
            // {
            //     title: 'Full Year',
            //     price: '99.99',
            //     id: 'plan_id3',
            //     benefits: ['Unlimited Premium Access', 'Unlimited High Definition Downloads', 'High Priority Download Speeds'],
            //     color_scheme: 'orange'
            // },
        ]
    }

    componentDidMount() {
        this.mounted = true
        axios.get('/api/get_prices?capacity=deferred')
            .then(r => {
                if (!this.mounted) return
                const plans = r.data.plans
                this.setState({ plans, account: r.data.account })
                if (!plans.length) return
                const query = plans.map(p => `plan_id=${encodeURIComponent(p.plan_id)}`).join('&')
                return axios.get(`/api/paypal_capacity?${query}`)
                    .then(result => {
                        if (!this.mounted) return
                        const availability = new Map(result.data.plans.map(p => [p.plan_id, p]))
                        this.setState({ plans: plans.map(p => ({ ...p, ...availability.get(p.plan_id) })) })
                    })
                    .catch(() => {
                        if (this.mounted) this.setState({ plans: plans.map(p => ({ ...p, paypal_available: false,
                            paypal_message: 'Payment availability could not be checked. Please refresh to try again.' })) })
                    })
            })
            .catch(() => {
                if (this.mounted) this.setState({ error: 'Prices could not be loaded. Please refresh to try again.' })
            })
    }

    componentWillUnmount() {
        this.mounted = false
    }

    render() {
        let { plans } = this.state
        const account = this.state.account || {}
        plans = plans.slice(1,3)
        return (
            <div className="store_container_container">
                <div className='store_container'>
                    {account.premium && <div className='premium_status_row'>
                        <section className='premium_status_card card' aria-label='Premium account status'>
                            <span className='premium_status_check' aria-hidden='true'><Icon size={52} icon={ic_check_circle} /></span>
                            <h1>Your account has premium.</h1>
                        </section>
                    </div>}
                    {this.state.error && <p role='alert'>{this.state.error}</p>}
                    {(!account.premium || account.admin) && plans.map(p => <PaymentTier key={p.plan_id} {...p} history={this.props.history} />)}
                </div>
            </div>
        )
    }
}

export default withRouter(StorePage)
